import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import Reveal from "@/components/Reveal";
import EnquiryForm from "@/components/public/EnquiryForm";
import { IMAGES } from "@/lib/images";

const TYPES = [
  "Suppliers", "Manufacturers", "Technology partners", "Property partners",
  "Strategic partnerships", "Distribution partners", "Corporate partners",
];

export default function Partnerships() {
  const [ventures, setVentures] = useState([]);
  useEffect(() => { api.get("/ventures").then(({ data }) => setVentures(data)).catch(() => {}); }, []);

  return (
    <div data-testid="page-partnerships" className="bg-bd-ivory min-h-screen">
      <section className="pt-40 pb-20 bg-bd-black grain relative">
        <img src={IMAGES.goldSculpture} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-t from-bd-black to-bd-black/70" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <p className="overline text-bd-gold mb-6">Partnerships</p>
            <h1 className="font-serif text-4xl md:text-7xl text-bd-ivory leading-[1.05] max-w-4xl">
              Partnering with those who share our standards
            </h1>
            <p className="mt-8 text-base md:text-lg text-bd-ivory/60 max-w-2xl leading-relaxed">
              We work with suppliers, manufacturers, technology, property, distribution and corporate partners who value quality, reliability and the long term.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="overline text-bd-gold mb-6">We partner with</p>
              <ul className="space-y-4">
                {TYPES.map((t) => (
                  <li key={t} className="flex items-start gap-3 text-black/75 border-b border-black/10 pb-4">
                    <span className="w-1.5 h-1.5 bg-bd-gold mt-2.5" />
                    <span className="text-lg font-serif">{t}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.15}>
              <div className="bg-white border border-black/10 p-8 md:p-12">
                <h2 className="font-serif text-3xl text-bd-black mb-2">Partnership enquiry</h2>
                <p className="text-sm text-black/50 mb-8">Tell us about your organisation and how we might work together.</p>
                <EnquiryForm
                  category="Partnership"
                  showCompany showPosition showPhone
                  showPartnershipType partnershipTypes={TYPES}
                  showVenture ventures={ventures}
                  showAttachment
                  submitLabel="Submit Partnership Enquiry"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
